import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getStorage, deleteStorage } from "../modals/Storage";
import general from "../css/General.module.css";
import screen from "../css/Screen.module.css";
import HeaderView from "../other-components/HeaderView/view";
import AlertDialog from "../dialogs/AlertDialog/dialog";
import FooterView from "../other-components/FooterView/view";

function Account() {
  const navigate = useNavigate();
  const [open, showSignOutAlert] = useState(false);

  const [pageConst, setConstants] = useState({
    showHeadSearch: true,
    toastMessage: "",
    toastDialogShow: false,
    isShowFooter: true,
    isLoadingShow: false,
  });

  const signOutAccount = () => {
    if (deleteStorage()) {
      navigate("/signin", { replace: true });
    }
  };

  useEffect(() => {
    if (!getStorage("accountID") || getStorage("accountID") == "") {
      navigate("/signin", { replace: true });
    }
  }, []);

  return (
    <div className={[general.appView]}>
      <AlertDialog
        isOpen={open}
        title={"Alert!"}
        description="Are you sure you want to sign out of this account?"
        onClose={() => showSignOutAlert(false)}
        actions={[
          { label: "No", variant: "neutral", onClick: () => showSignOutAlert(false) },
          { label: "Yes, Signout", variant: "positive", onClick: () => signOutAccount() }
        ]}
      />

      <div className={[general.appChildView]}>
        <HeaderView categories={pageConst.categoryList} screen={"account"} />

        <div className={general.appLocationViews}>
          <p>My Account</p>
        </div>

        <div className={[general.appContentsView]}>
          <div className={screen.accountView}>
            <Link className={screen.item} to={"/update-profile"}>
              <h3>My Profile</h3>
              <p>Edit personal info, change password</p>

              <button>
                View
              </button>
            </Link>

            <Link className={screen.item} to={"/myaddress"}>
              <h3>My Addresses</h3>
              <p>Edit, add or remove addresses</p>

              <button>
                View
              </button>
            </Link>

            <Link className={screen.item} to={"/myorders"}>
              <h3>My Orders</h3>
              <p>View, modify and track orders</p>

              <button>
                View
              </button>
            </Link>

            <Link className={screen.item} to={"/mybag"}>
              <h3>My Bag</h3>
              <p>View, remove and order products</p>

              <button>
                View
              </button>
            </Link>

            <div className={screen.item} onClick={() => showSignOutAlert(true)}>
              <h3>Logout</h3>
              <p>Remove account from this device</p>
            </div>
          </div>
        </div>

        <FooterView />
      </div>
    </div >
  );
}

export default Account;
